const punctualityReport = {
  namespaced: true,
  state: {
    availableBlocks: [],
    availableLines: [],
    availableLineNumbers: [],
    availableLinesByBlock: {},
    availableLineNumbersByBlock: {},
    punctualityReportList: [],
  },
  mutations: {
    updateAvailableBlocks(state, newList) {
      state.availableBlocks = newList
    },
    updateAvailableLines(state, newList) {
      state.availableLines = newList
    },
    updateAvailableLineNumbers(state, newList) {
      state.availableLineNumbers = newList
    },
    updateAvailableLinesByBlock(state, newBlockLines) {
      state.availableLinesByBlock = newBlockLines
    },
    updateAvailableLineNumbersByBlock(state, newBlockLines) {
      state.availableLineNumbersByBlock = newBlockLines
    },
    updatePunctualityReportList(state, newList) {
      state.punctualityReportList = newList
    },
  },
  actions: {
    getAvailableBlocks(context) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/deviationreport/getAvailableBlocks')
          .then((response) => {
            if (response.status == 200) {
              context.commit('updateAvailableBlocks', response.data)
            }
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    getAvailableLines(context) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/deviationreport/getAvailableLines')
          .then((response) => {
            if (response.status == 200) {
              context.commit('updateAvailableLines', response.data)
            }
            resolve(response)
          }),
          (error) => {
            console.error('getAvailableLines error')
            reject(error)
          }
      })
    },
    getAvailableLineNumbers(context) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/deviationreport/getAvailableLineNumbers')
          .then((response) => {
            if (response.status == 200) {
              context.commit('updateAvailableLineNumbers', response.data)
            }
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    getAvailableLinesByBlock(context) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/deviationreport/getAvailableLinesByBlock')
          .then((response) => {
            if (response.status == 200) {
              context.commit('updateAvailableLinesByBlock', response.data)
            }
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    getAvailableLineNumbersByBlock(context) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get(
            '/traveller/restui/deviationreport/getAvailableLineNumbersByBlock'
          )
          .then((response) => {
            if (response.status == 200) {
              context.commit('updateAvailableLineNumbersByBlock', response.data)
            }
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    getPunctualityReportList(context, data) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/deviationreport/getDeviationReportList', {
            params: data,
          })
          .then((response) => {
            if (response.status == 200) {
              context.commit('updatePunctualityReportList', response.data)
            }
            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
    exportXLS(context, data) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/deviationreport/exportXLS', {
            params: data,
            responseType: 'blob',
          })
          .then((response) => {
            const blob = new Blob([response.data], { type: 'application/xlsx' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'punctuality_report.xlsx'
            link.click()
            URL.revokeObjectURL(link.href)

            resolve(response)
          }),
          (error) => {
            reject(error)
          }
      })
    },
  },
}
export default punctualityReport
